import { styled } from "baseui";

export const FieldLabelRow = styled("div", ({ $theme }) => ({
  ...$theme.typography.font350,
  width: "110px",
  textAlign: "right",
}));
